import React, { useState } from 'react';
import './UserAvatar.css';

interface UserAvatarProps {
  name: string;
  src?: string | null;
  /** Tried when `src` is missing or fails to load, before the initials. */
  fallbackSrc?: string | null;
  fallback?: string;
  size?: number;
  className?: string;
}

/** Decorative identity image beside a visible name; never fetches profiles itself. */
export default function UserAvatar({ name, src, fallbackSrc, fallback, size, className }: UserAvatarProps) {
  const [failedSrcs, setFailedSrcs] = useState<string[]>([]);
  const initials = fallback ?? (name.trim().split(/\s+/).filter(Boolean).slice(0, 2).map(part => part[0]).join('').toLocaleUpperCase() || '?');
  const imageSrc = [src, fallbackSrc].find(candidate => candidate && !failedSrcs.includes(candidate)) || null;
  return (
    <span className={['user-avatar', className].filter(Boolean).join(' ')} aria-hidden="true"
      style={size ? { width: size, height: size, fontSize: Math.max(10, Math.round(size * .32)) } : undefined}>
      {imageSrc
        ? <img className="user-avatar__image" src={imageSrc} alt="" loading="lazy" decoding="async" onError={() => setFailedSrcs(prev => [...prev, imageSrc])} />
        : initials}
    </span>
  );
}
